import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { Mandarin } from "flatpickr/dist/l10n/zh.js"

// Connects to data-controller="flatpickr-modal"
export default class extends Controller {
  static targets = ["province", "input", "price", "algorithmName"]

  connect() {
    this.flatpickr = flatpickr(this.inputTarget, {
      mode: "range",
      dateFormat: "Y-m-d",
      locale: {
        ...Mandarin,
        firstDayOfWeek: 1,
        rangeSeparator: " ~ ",
        weekdays: {
          shorthand: ["日", "一", "二", "三", "四", "五", "六"],
          longhand: Mandarin.weekdays.longhand,
        },
      },
      minDate: "2025-01-01",
      defaultDate: this.#getDefaultThirtyDays(),
      onClose: (selectedDates, dateStr, instance) => {
        if (selectedDates.length !== 2) {
          instance.setDate(this.flatpickr.selectedDates)
        }
      },
    })
  }

  disconnect() {
    this.flatpickr.destroy()
  }

  async submit() {
    const province = this.provinceTarget.value
    const dates = this.flatpickr.selectedDates
    if (dates.length !== 2) return console.error("Invalid date range.")

    const algorithmName = this.hasAlgorithmNameTarget
      ? this.algorithmNameTarget.value.trim()
      : null
    if (this.hasAlgorithmNameTarget && !algorithmName) {
      this.algorithmNameTarget.focus()
      return console.error("Algorithm name is required.")
    }

    const startDate = this.flatpickr.formatDate(dates[0], "Y-m-d")
    const endDate = this.flatpickr.formatDate(dates[1], "Y-m-d")

    const url = new URL(
      `/admin/${this.hasPriceTarget ? "price" : "strategy"}/export`,
      window.location.origin,
    )
    const params = {
      province: province,
      start_date: startDate,
      end_date: endDate,
    }
    if (this.hasPriceTarget) {
      params.price = this.priceTarget.value
    }
    if (algorithmName) {
      params.algorithm_name = algorithmName
    }
    Object.entries(params).forEach(([key, value]) =>
      url.searchParams.append(key, value),
    )

    console.log("request to URL: ", url.toString())

    // 使用原生的 <a> 标签下载，避免 fetch/blob 在代理环境下的问题
    const a = document.createElement("a")
    a.href = url.toString()
    a.setAttribute("data-turbo", "false")
    a.download = `${province}_${
      this.hasPriceTarget ? this.priceTarget.value : "forecast"
    }_${startDate}_${endDate}.csv`
    document.body.appendChild(a)
    a.click()

    setTimeout(() => {
      a.remove()
    }, 500)
  }

  #getDefaultThirtyDays() {
    const yesterday = this.#yesterday()

    const thirtyDaysAgo = new Date(yesterday)
    thirtyDaysAgo.setDate(yesterday.getDate() - 29)
    thirtyDaysAgo.setHours(0, 0, 0, 0)
    return [thirtyDaysAgo, yesterday]
  }

  #yesterday() {
    const d = new Date()
    d.setDate(d.getDate() - 1)
    d.setHours(0, 0, 0, 0)
    return d
  }
}
